import React from 'react';
import { motion } from 'framer-motion';
import { Home, PaintBucket, Zap, TrendingUp, DollarSign, Wrench } from 'lucide-react';
export function WhyDifferent() {
  const cards = [{
    icon: Home,
    text: 'Remodela espacios existentes'
  }, {
    icon: PaintBucket,
    text: 'Acabado moderno y premium'
  }, {
    icon: Zap,
    text: 'Aplicación rápida'
  }, {
    icon: TrendingUp,
    text: 'Creciente demanda'
  }, {
    icon: DollarSign,
    text: 'Trabajos bien remunerados'
  }, {
    icon: Wrench,
    text: 'No requiere maquinaria industrial'
  }];
  return <section className="py-12 md:py-16 px-4 bg-brand-gray border-t border-white/5" data-id="element-212">
      <div className="max-w-5xl mx-auto" data-id="element-213">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-12" data-id="element-214">
          <h2 className="text-4xl md:text-6xl text-white" data-id="element-215">
            POR QUÉ EL MICROCEMENTO ES UNA DE LAS HABILIDADES MÁS{' '}
            <span className="text-brand-yellow" data-id="element-216">INTERESANTES DE HOY.</span>
          </h2>
        </motion.div>

        <div className="flex flex-col gap-4 max-w-3xl mx-auto" data-id="element-217">
          {cards.map((card, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-dark p-5 rounded-2xl border border-brand-yellow/10 hover:border-brand-yellow/30 transition-colors group flex items-center gap-4" data-id="element-218">
              <div className="bg-brand-yellow/10 w-12 h-12 rounded-xl flex items-center justify-center shrink-0 group-hover:bg-brand-yellow/20 transition-colors" data-id="element-219">
                <card.icon className="text-brand-yellow w-6 h-6" data-id="element-220" />
              </div>
              <h3 className="text-lg font-bold text-white normal-case tracking-normal text-left" data-id="element-221">
                {card.text}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}